// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__mFiho","tab":"Tabs_tab__2PR-D","tabActive":"Tabs_tabActive__2eAeT"};